import { useLocation } from "react-router-dom";
import { useRef, useMemo } from "react";
import ThreeJSViewerLight from "../components/ModelViewer/ThreeJSViewer/ThreeJSViewerLight.js";

function HeadlessRenderer() {
    const viewer = useRef();
    const location = useLocation();
    const {
        modelUrl,
        skuModel,
        templateConfig,
    } = useMemo(() => {
        const queryParams = new URLSearchParams(location.search);

        // Estrai tutti i dati necessari direttamente dai parametri URL
        const tConfig = JSON.parse(queryParams.get("templateConfig"));
        
        return {
            modelUrl: queryParams.get("modelUrl"),
            skuModel: queryParams.get("skuModel"),
            templateConfig: tConfig,
        };
    }, [location.search]);

    const PROJECT_PARAMS = {
        ar: "true",
        autoRotate: false,
        backgroundColor: templateConfig?.background_color || "#ffffff",
        isBackgroundImage: false,
        backgroundImage: "",
        cameraControls: true,
        cameraOrbit: "",
        disableZoom: false,
        exposure: templateConfig?.light_exposition || 1,
        lightExposition: templateConfig?.light_exposition || 1,
        shadowIntensity: 0.5,
        shadowSmooth: 0.3,
    };

    const RENDER_OPTIONS = {
        cameraFov: templateConfig?.camera_fov,
        cameraPosition: templateConfig?.camera_position,
        cameraRotation: templateConfig?.camera_rotation,
        cameraLookAt: templateConfig?.camera_look_at,
        download: false,
    };

    // La funzione globale per il worker
    window.triggerServerRender = async (params) => {
        console.log("Triggering Headless Server Render...");
        if (viewer.current && skuModel) {
            return await viewer.current.onRender(
                skuModel,
                params.width,
                params.height,
                RENDER_OPTIONS
            );
        }
        throw new Error("Viewer or SKU Model not ready.");
    };

    // Se non c'è un URL per il modello, non renderizzare nulla
    if (!modelUrl) {
        // Imposta isSceneReady a false o gestisci l'errore
        window.isSceneReady = false;
        return <div>Errore: modelUrl non fornito nei parametri.</div>;
    }

    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            <ThreeJSViewerLight
                ref={viewer}
                singleView
                singleSrc={modelUrl}
                isRenderer
                project={PROJECT_PARAMS}
            />
        </div>
    );
}

export default HeadlessRenderer;